import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { CalendarDays, MapPin } from "lucide-react";
import { ASSETS } from "../../data/assets";
import { EVENT } from "../../data/mockData";
import { StatusBadge } from "./StatusBadge";

// Collectible BLTR event pass
export function TicketPass({ ticket }) {
  if (!ticket) return null;
  return (
    <div className="max-w-md w-full mx-auto" data-testid="ticket-pass">
      <div className="relative bg-white rounded-[2rem] border-4 border-white shadow-playful-lg overflow-hidden">
        {/* header */}
        <div className="bg-sky-dark relative px-6 pt-5 pb-8 text-white text-center">
          <img src={ASSETS.logo} alt="BLTR 2026" className="h-12 mx-auto bg-white rounded-2xl px-2 py-1" />
          <p className="mt-2 font-display text-lg">Family Event Pass</p>
        </div>
        {/* perforation */}
        <div className="relative">
          <div className="absolute -left-3 -top-3 w-6 h-6 rounded-full bg-sky-scene" />
          <div className="absolute -right-3 -top-3 w-6 h-6 rounded-full bg-sky-scene" />
          <div className="border-t-2 border-dashed border-slate-200" />
        </div>
        {/* body */}
        <div className="p-6">
          <div className="flex items-center justify-between gap-4">
            <div>
              <p className="text-xs uppercase font-bold text-sea-deep/50">Ticket Code</p>
              <p className="font-display text-2xl text-coral tracking-wider" data-testid="pass-ticket-code">{ticket.ticketCode}</p>
            </div>
            <div className="bg-white p-1 rounded-xl border-2 border-slate-100">
              <QRCodeSVG value={ticket.ticketCode} size={72} fgColor="#2B4C7E" />
            </div>
          </div>

          <div className="mt-4 grid grid-cols-2 gap-3 text-sm">
            <Field label="Orang Tua" value={ticket.parentName} />
            <Field label="Anak" value={`${ticket.childName}${ticket.childAge ? ` (${ticket.childAge}th)` : ""}`} />
            <Field label="Paket" value="Parent + Kiddo" />
            <div>
              <p className="text-xs uppercase font-bold text-sea-deep/50">Status</p>
              <div className="mt-1"><StatusBadge status={ticket.paymentStatus} /></div>
            </div>
          </div>

          <div className="mt-4 pt-4 border-t border-slate-100 flex flex-wrap gap-x-4 gap-y-1 text-sm font-bold text-sea-deep/80">
            <span className="flex items-center gap-1"><CalendarDays className="w-4 h-4 text-coral" /> {EVENT.dateLabel}</span>
            <span className="flex items-center gap-1"><MapPin className="w-4 h-4 text-coral" /> {EVENT.venue}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

function Field({ label, value }) {
  return (
    <div>
      <p className="text-xs uppercase font-bold text-sea-deep/50">{label}</p>
      <p className="font-display text-sea-deep truncate">{value}</p>
    </div>
  );
}
